import React from "react";
import { LinearProgress, Step, StepLabel, Stepper } from "@mui/material";
import { useTranslation } from "react-i18next";

const StepsStepper = ({ currentStep, steps }) => {
  const {t} = useTranslation();
  return (
    <div className="md:mb-6">
      <h2 className="text-[20px] md:text-[30px] md:text-center font-[600] text-black-600 mb-6">
        {t("firstFormSteps.completeHeading")}
      </h2>
      <LinearProgress
        variant="determinate"
        value={(currentStep / (steps.length - 1)) * 100}
        sx={{ height: 10, borderRadius: 5, display: "none" }}
      />
      <Stepper activeStep={currentStep} alternativeLabel className="mt-4">
        {steps.map((step) => (
          <Step key={step.title} completed={steps.indexOf(step) < currentStep}>
            <StepLabel
              className="labelStep"
              slotProps={{
                stepIcon: {
                  sx: {
                    fontSize: {
                      xs: "18px",
                      md: "40px",
                    },
                    fontWeight: 700,
                  },
                },
              }}
              sx={{
                "& .MuiStepLabel-label": {
                  fontSize: {
                    xs: "0px",
                    sm: "12px",
                    md: "14px",
                  },
                  display: {
                    xs: "none",
                    sm: "block",
                  },
                  fontWeight:"400"
                },
              }}
            >
              {step.title}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

export default StepsStepper;